import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import { media } from 'ui/rwd'
import { Section } from '../HomepageStyledComponents'
import Button from '../../../components/shared/Button/Button'

const ContactSection = styled(Section)`
  padding-top: 3.5rem;
  padding-bottom: 4rem;
  ${media.sm`
    padding-top: 4.5rem;
    padding-bottom: 5rem;
  `}
  ${media.md`
    padding-top: 5.5rem;
    padding-bottom: 6rem;
  `}
`

const ContactLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas:
    'copy'
    'form';
  gap: 2.5rem;
  text-align: left;
  ${media.md`
    grid-template-columns: minmax(0, 0.58fr) minmax(0, 0.42fr);
    grid-template-areas: 'form copy';
    gap: 4rem;
    align-items: center;
  `}
`

const ContactCopy = styled.div`
  grid-area: copy;
  min-width: 0;
`

const ContactKicker = styled.p`
  margin: 0 0 0.65rem;
  font-size: 0.8125rem;
  font-weight: bold;
  letter-spacing: 0.08em;
  line-height: 1.3;
  text-transform: uppercase;
  color: ${theme('pink')};
`

const ContactCard = styled.div`
  grid-area: form;
  min-width: 0;
  box-sizing: border-box;
  padding: 1.75rem 1.5rem 2rem;
  background-color: ${theme('white')};
  border: 1px solid ${theme('lightGray')};
  box-shadow: 0 2px 12px -6px rgba(30, 27, 28, 0.18);
  ${media.sm`
    padding: 2rem 1.75rem 2.25rem;
  `}
`

const ContactHeading = styled.h2`
  margin: 0;
  font-size: 1.75rem;
  font-weight: bold;
  line-height: 1.2;
  letter-spacing: -0.02em;
  ${media.sm`
    font-size: 2rem;
  `}

  &::after {
    content: '';
    display: block;
    width: 2.5rem;
    height: 3px;
    margin-top: 1rem;
    background-color: ${theme('yellow')};
    transition: width 0.3s ease;
  }

  &:hover::after,
  &:focus-within::after {
    width: 4.5rem;
  }

  @media (prefers-reduced-motion: reduce) {
    &::after {
      transition: none;
    }
  }
`

const ContactBody = styled.p`
  margin: 1.25rem 0 0;
  max-width: 32rem;
  font-size: 1.0625rem;
  line-height: 1.7;
  color: ${theme('midGray')};
  ${media.sm`
    font-size: 1.125rem;
  `}
`

const ContactEmail = styled.a`
  display: inline-block;
  margin-top: 1.5rem;
  font-weight: bold;
  font-size: 1.0625rem;
  color: ${theme('black')};
  text-decoration: none;
  border-bottom: 2px solid ${theme('yellow')};

  &:hover,
  &:focus {
    color: ${theme('black')};
    background-color: ${theme('yellow')};
  }
`

const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
`

const ContactField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`

const ContactLabel = styled.label`
  font-size: 0.8125rem;
  font-weight: bold;
  line-height: 1.3;
  color: ${theme('black')};
`

const ContactInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 0.85rem 1rem;
  border: 1px solid ${theme('lightGray')};
  border-radius: 0;
  font: inherit;
  font-size: 1rem;
  color: ${theme('black')};
  background-color: ${theme('white')};

  &::placeholder {
    color: ${theme('midGray')};
  }

  &:focus {
    border-color: ${theme('black')};
    outline: none;
  }
`

const ContactTextarea = styled(ContactInput).attrs({ as: 'textarea' })`
  min-height: 8rem;
  resize: vertical;
  line-height: 1.5;
`

const ContactError = styled.p`
  margin: 0;
  font-size: 0.8125rem;
  color: ${theme('danger')};
`

const ContactSubmit = styled(Button)`
  width: 100%;
  margin-top: 0.5rem;
  background-color: ${theme('yellow')};
  border-color: ${theme('yellow')};
  color: ${theme('black')};

  &:hover,
  &:focus {
    background-color: #f0d256;
    border-color: #f0d256;
    color: ${theme('black')};
    text-decoration: none;
  }
`

export {
  ContactSection,
  ContactLayout,
  ContactCopy,
  ContactCard,
  ContactKicker,
  ContactHeading,
  ContactBody,
  ContactEmail,
  ContactForm,
  ContactField,
  ContactLabel,
  ContactInput,
  ContactTextarea,
  ContactError,
  ContactSubmit
}
